import React, { useState } from 'react';
import './App.css';
import { API_BASE_URL } from './config';
import ControlRoom from './components/ControlRoom';
import CharacterChat from './components/CharacterChat';
import HoratioPanel from './components/HoratioPanel';
import CueWizard from './components/CueWizard';
import KnowledgeNodes from './components/KnowledgeNodes';
import IdeaAtlas from './components/IdeaAtlas';
import BlockchainArchive from './components/BlockchainArchive';
import Immortalize from './components/Immortalize';
import Opportunities from './components/Opportunities';

function App() {
  const [tab, setTab] = useState('live');
  const [restartNeeded, setRestartNeeded] = useState(false);

  React.useEffect(() => {
    try {
      const hash = window.location.hash || '';
      const route = hash.replace(/^#/, '').split('?')[0];
      const set = (t) => setTab(t);
      switch ((route || '').toLowerCase()) {
        case 'control-room': set('live'); break;
        case 'highlights': set('live'); break; // same tab, different panel is fine for now
        case 'wizard': set('wizard'); break;
        case 'characters': set('characters'); break;
        case 'nodes':
        case 'knowledge': set('nodes'); break;
        case 'horatio': set('horatio'); break;
        case 'opportunities': set('opportunities'); break; // Admin-only (hidden)
        default: break;
      }
    } catch {}
  }, []);

  // Check for restart flag periodically
  React.useEffect(() => {
    const checkRestart = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/admin/coverage`);
        if (response.status === 401) {
          setRestartNeeded(true);
        } else {
          setRestartNeeded(false);
        }
      } catch (e) {
        // If API call fails, might indicate restart needed
        setRestartNeeded(true);
      }
    };

    checkRestart();
    const interval = setInterval(checkRestart, 30000); // Check every 30 seconds
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="App">
      <div style={{ position:'fixed', top:6, right:8, zIndex:1000, fontSize:11, opacity:0.75, textAlign:'right' }}>
        API: {API_BASE_URL}
        <br />
        Build: {process.env.REACT_APP_BUILD || 'dev'}
        {restartNeeded && (
          <div style={{
            marginTop: '8px',
            padding: '4px 8px',
            backgroundColor: '#ff4444',
            color: 'white',
            borderRadius: '4px',
            fontSize: '10px',
            fontWeight: 'bold'
          }}>
            🔄 RESTART REQUIRED
            <br />
            <span style={{fontSize: '9px', fontWeight: 'normal'}}>
              Backend updated - refresh page
            </span>
          </div>
        )}
      </div>
      <div className="bitbard-tabs">
        <button className={tab === 'live' ? 'active' : ''} onClick={() => setTab('live')}>Troupe Feed ✨</button>
        <button className={tab === 'wizard' ? 'active' : ''} onClick={() => setTab('wizard')}>Start a Scene</button>
        <button className={tab === 'characters' ? 'active' : ''} onClick={() => setTab('characters')}>Character Chat</button>
        <button className={tab === 'nodes' ? 'active' : ''} onClick={() => setTab('nodes')}>Knowledge Map</button>
        <button className={tab === 'horatio' ? 'active' : ''} onClick={() => setTab('horatio')}>Ask Horatio</button>
        <button className={tab === 'imm' ? 'active' : ''} onClick={() => setTab('imm')}>Immortalize</button>
      </div>
      {tab === 'live' && <div className="scene-reader-container"><ControlRoom /></div>}
      {tab === 'wizard' && <div className="scene-reader-container"><div className="console-header" style={{marginBottom:6}}>Start a Scene</div><div className="line" style={{opacity:.85, margin:'4px 0'}}>Issue a scene cue (praise, solo, duel, rewrite, roast).</div><CueWizard /></div>}
      {tab === 'characters' && <div className="character-reader-container"><div className="console-header" style={{marginBottom:6}}>Character Chat</div><CharacterChat /></div>}
      {tab === 'nodes' && <IdeaAtlas />}
      {tab === 'horatio' && <div className="character-reader-container"><div className="console-header" style={{marginBottom:6}}>Ask Horatio</div><HoratioPanel /></div>}
      {tab === 'imm' && <div className="scene-reader-container"><div className="console-header" style={{marginBottom:6}}>Immortalize: Weekly Poll</div><Immortalize /></div>}
      {tab === 'opportunities' && <div className="scene-reader-container"><Opportunities /></div>}
      {/* Temporary access: navigate via #archive in hash if desired */}
      {window.location.hash.replace(/^#/, '').toLowerCase() === 'archive' && (
        <div className="scene-reader-container"><div className="console-header" style={{marginBottom:6}}>Blockchain Archive</div><BlockchainArchive /></div>
      )}
    </div>
  );
}

export default App;
